import React from 'react';
import { documentTypeEnum } from '../../enum';

const RenderHeader = (props) => {

    const { titulo, docType } = props;

    return (

        <div className="ui right aligned grid">
            <div className="column">
                <span className={`ui ${docType === documentTypeEnum.FacturaCompra ? 'yellow' : 'green'} tag label`}>
                    <h3> {titulo} </h3>
                </span>
            </div>
        </div>


    )

}


export default (RenderHeader);